import { render, staticRenderFns } from "./CardProductHome.vue?vue&type=template&id=34645a88&scoped=true&"
import script from "./CardProductHome.vue?vue&type=script&lang=js&"
export * from "./CardProductHome.vue?vue&type=script&lang=js&"
import style0 from "./CardProductHome.vue?vue&type=style&index=0&id=34645a88&scoped=true&lang=css&"
import style1 from "./CardProductHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34645a88",
  null
  
)

export default component.exports